"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ = require("./..");

var TextInput = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var multiLine = props.multiLine,
      _onChange = props.onChange,
      moreProps = (0, _objectWithoutPropertiesLoose2.default)(props, ["multiLine", "onChange"]);
  return multiLine ? /*#__PURE__*/_react.default.createElement("textarea", (0, _extends2.default)({
    onChange: function onChange(event) {
      return _onChange(event.target.value, event);
    }
  }, moreProps)) : /*#__PURE__*/_react.default.createElement(_.Input, (0, _extends2.default)({
    onChange: function onChange(event) {
      return _onChange(event.target.value, event);
    },
    ref: ref
  }, moreProps));
});
TextInput.propTypes = {
  multiLine: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  placeholder: _propTypes.default.string
};
TextInput.defaultProps = {
  multiLine: false,
  onChange: function onChange() {
    return '';
  },
  placeholder: ' ' // Whitespace needed

};
TextInput.displayName = 'TextInput';
var _default = TextInput;
exports.default = _default;